import { render } from "./languageSwitcher.vue?vue&type=template&id=9eb55f7c&scoped=true"
import script from "./languageSwitcher.vue?vue&type=script&lang=js"
export * from "./languageSwitcher.vue?vue&type=script&lang=js"

import "./languageSwitcher.vue?vue&type=style&index=0&id=9eb55f7c&scoped=true&lang=scss"

import exportComponent from "/builds/simply-frontend/simply-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb55f7c"]])

export default __exports__